import * as constants from './constants';

export const initialState = {
  loading: false,
  data: [],
  error: null,
};

export const categoriesReducer = (state = initialState, action) => {
  switch (action.type) {
  case constants.GET_CATEGORIES:
    return { ...state, loading: true };
  case constants.GET_CATEGORIES_SUCCESS: {
    return { ...state, loading: false, data: action.payload };
  }
  case constants.GET_CATEGORIES_ERROR:
    return { ...state, loading: false, error: action.payload };
  case constants.RESET_CATEGORIES:
    return initialState;
  default:
    return state;
  }
};

export const initialUserCategoriesState = {
  loading: false,
  data: [],
  error: null,
};

export const userCategoriesReducer = (state = initialUserCategoriesState, action) => {
  switch (action.type) {
  case constants.GET_USER_CATEGORIES:
  case constants.REMOVE_USER_CATEGORY:
  case constants.ADD_USER_CATEGORY:
    return { ...state, loading: true };
  case constants.GET_USER_CATEGORIES_SUCCESS: {
    return { ...state, loading: false, data: action.payload };
  }
  case constants.GET_USER_CATEGORIES_ERROR:
    return { ...state, loading: false, error: action.payload };
  case constants.RESET_USER_CATEGORIES:
    return initialUserCategoriesState;
  case constants.REMOVE_USER_CATEGORY_ERROR:
  case constants.REMOVE_USER_CATEGORY_SUCCESS:
  case constants.ADD_USER_CATEGORY_ERROR:
  case constants.ADD_USER_CATEGORY_SUCCESS:
    return { ...state, loading: false };
  default:
    return state;
  }
};
